<template>
  <div
    id="content"
    class="content"
    style="margin-left:0px;"
  >
    <h1
      class="page-header"
      style="text-align:left"
    >
      出库管理&nbsp;<small>/&nbsp;<router-link to="/outbound" class="TitleStyle">出库单管理列表&nbsp;</router-link>/&nbsp;新增出库单</small>
    </h1>

    <!-- end col-6 -->
    <div
      id="page-container"
      class="in page-sidebar-fixed page-header-fixed"
      style="padding-top:0px;"
    >
      <!-- begin #content -->
      <div
        id="content"
        class="content"
        style="margin-left:0px;padding-top: 0px;padding-left:0px;padding-right:0px;"
      >
        <!-- begin breadcrumb -->

        <div class="row">
          <!-- begin col-10 -->
          <div class="col-lg-12">
            <!-- begin panel -->
            <div class="panel panel-inverse">
              <!-- begin panel-heading -->
              <div class="panel-heading">
                <div class="panel-heading-btn">
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-default"
                    data-click="panel-expand"
                  >
                    <i class="fa fa-expand"></i>
                  </a>
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-success"
                    data-click="panel-reload"
                  >
                    <i class="fa fa-redo"></i>
                  </a>
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-warning"
                    data-click="panel-collapse"
                  >
                    <i class="fa fa-minus"></i>
                  </a>
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-danger"
                    data-click="panel-remove"
                  >
                    <i class="fa fa-times"></i>
                  </a>
                </div>
                <h4 class="panel-title panelTitle">新增出库单</h4>
              </div>
              <!-- begin panel-body -->
              <div class="panel-body">
                <el-form :inline="true" :model="ruleForm" :rules="rules" ref="ruleForm" label-width="28%" style="text-align:left;margin-top:16px;margin-bottom:20px;border-bottom :1px dashed #6a7786" class="formStyle">
                  <el-form-item label="服务商" prop="recomId">
                    <el-select v-model="ruleForm.recomId" placeholder="请选择" style="width:100%;">
                        <el-option
                        v-for="item in recomList"
                        :key="item.recomId"
                        :label="item.recomName"
                        :value="item.recomId">
                        </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="仓库名称" prop="manualId">
                    <el-select v-model="ruleForm.manualId" placeholder="请选择" style="width:100%;">
                        <el-option
                        v-for="item in warehouseList"
                        :key="item.manualId"
                        :label="item.name"
                        :value="item.manualId">
                        </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item style="padding-left:32px;">
                    <a class="btn btn-primary m-r-5" style="color:#fff;" @click="submitForm('ruleForm')">提交</a>
                  </el-form-item>
                </el-form>
                <el-form :inline="true" :model="formInline" :rules="rules" ref="formInline" label-width="25%" style="text-align:left;" class="formStyle">
                  <el-form-item label="商品名称" prop="goodsId">
                    <v-selectpage
                        title=""
                        :data="GoodList"
                        key-field="goodsId"
                        show-field="goodsName"
                        placeholder="请选择"
                        v-model="formInline.goodsId"
                        style="70%;"
                        @values="getSelectGood"
                    ></v-selectpage>
                  </el-form-item>
                  <el-form-item label="商品数量" prop="detailCount">
                    <el-input v-model.number="formInline.detailCount" placeholder="商品数量"></el-input>
                  </el-form-item>
                  <el-form-item label="备注" prop="note">
                    <el-input v-model="formInline.note" placeholder="备注"></el-input>
                  </el-form-item>
                  <a class="btn btn-primary m-r-5" style="color:#fff;" @click="AddGoods('formInline')">添加</a>
                </el-form>
                <el-table :data="TableContent" style="width: 100%;padding:0 30px;">
                  <el-table-column prop="goodsName" width="500" label="商品名称"></el-table-column>
                  <el-table-column prop="detailCount" width="300" label="商品数量"></el-table-column>
                  <el-table-column prop="note" width="200" label="备注"></el-table-column>
                  <el-table-column label="操作" align="center">
                    <template slot-scope="scope">
                      <el-button @click.native.prevent="deleteRow(scope.$index, TableContent)" type="text" size="small">删除</el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
              <!-- end panel-body -->
              <div style="height:66px;padding-top:16px;padding-right:6px;">
                <a
                  class="btn btn-primary m-r-5"
                  style="float:right;cursor:pointer;color:#fff !important"
                  @click="Goback"
                >返&nbsp;&nbsp;回</a>

                <span class="clear"></span>
              </div>

            </div>
            <!-- end panel -->
          </div>
          <!-- end col-10 -->

        </div>
        <!-- end row -->
      </div>
      <!-- end #content -->
    </div>
  </div>
</template>

<script>
import Qs from "qs";
import axios from "axios";
import http from "@/common/http";
import MethodsBus from "@/common/methodBus";
import eventBus from "@/common/eventBus";
export default {
  name: "AddPurchaseOrder",
  data() {
    return {
      TableContent: [],
      recomList: [],
      GoodList:[],
      formInline: {
        goodsId:'',
        detailCount:'',
        note:''
      },
      rules:{
        recomId:[{required: true, message: '请选择服务商', trigger: 'blur' }],
        manualId:[{required: true, message: '请选择仓库', trigger: 'blur' }],
        goodsId:[{required: true, message: '请选择商品', trigger: 'blur' }],
        detailCount:[{required: true, message: '请输入商品数量' }, { type: 'number', message: '商品数量必须为数字值'}]
      },
      ruleForm:{},
      warehouseList:[],
      director:0
    };
  },
  mounted: function() {
    this.getWarehouseList();
    this.GetGoodsInfo();
    this.getRecomList();
  },
  methods: {
    // 获取仓库列表
    getWarehouseList() {
      let that = this;
      const options = {
        url: "/distribution/B2cWarehouseController/getAllWarehouse",
        method: "post",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        data: Qs.stringify({
          director: that.director
        })
      };
      axios(options).then(function(response) {
        if (response.data.code == 200) {
          that.warehouseList = response.data.data.records;
        } else {
          http.handleEorrorCode(response,that);
        }
      })
       .catch((error) => {
          http.handleHttpError(error, that);
        });
    },
    // 获取服务商列表
    getRecomList() {
      let that = this;
      const options = {
        url: "distribution/B2cRecomInfoController/getRecomInfoByCompany",
        method: "post",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        data: Qs.stringify({
          director: that.director
        })
      };
      axios(options).then(function(response) {
        if (response.data.code == 200) {
          that.recomList = response.data.data;
        } else {
          http.handleEorrorCode(response,that);
        }
      })
       .catch((error) => {
          http.handleHttpError(error, that);
        });
    },
    deleteRow(index, rows) {
      rows.splice(index, 1);
    },
    Goback() {
      this.$router.push({
        path: "/outbound"
      });
    },
    GetGoodsInfo() {
      let that = this;
      const options = {
        url: "/distribution/B2cTobOutController/queryOutGoodsInfo",
        method: "post",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        data: Qs.stringify({})
      };
      axios(options)
        .then(function(response) {
          if (response.data.code == 200) {
            that.GoodList = response.data.data.result;
          } else {
            http.handleEorrorCode(response, that);
          }
        })
        .catch(error => {
          http.handleHttpError(error, that);
        });
    },
    getSelectGood(item){
      if(item){
        this.formInline.gooodsInfo = item;
      }
    },
    // 新增商品
    AddGoods(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let currentGoods = "";
          this.TableContent.forEach(val => {
            if (val.goodsId === this.formInline.gooodsInfo[0].goodsId ) {
                currentGoods = val.goodsId;
                this.$notify({
                  title: "失败",
                  message: "该商品已经选择",
                  type: "error"
                });
            }
          });
          if(currentGoods === ""){
            this.TableContent.push({
              goodsName:this.formInline.gooodsInfo[0].goodsName,
              goodsId:this.formInline.gooodsInfo[0].goodsId,
              detailCount: this.formInline.detailCount,
              note:this.formInline.note
            });
          }

        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    submitForm(formName){
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.TableContent.length === 0) {
            this.$notify({
              title: "失败",
              message: "请先新增一条商品信息",
              type: "error"
            });
          }else{
            let that = this;
            const options = {
              url: "/distribution/B2cTobOutController/addOut",
              method: "post",
              headers: { "Content-Type": "application/json" },
              data: {
                director: that.director,
                recomId: that.ruleForm.recomId,
                manualId: that.ruleForm.manualId,
                b2cTobOutDetails: that.TableContent
              }
            };
            axios(options).then(function(response) {
              if (response.data.code == 200) {
                that.$notify({
                  title: "成功",
                  message: response.data.message,
                  type: "success"
                });
                that.$router.push({ path: "/outbound" });
              } else {
                http.handleEorrorCode(response, that);
              }
            })
            .catch(error => {
                http.handleHttpError(error, that);
            });
          }
        }
      });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.TitleStyle {
  color: #6a7786;
}
.TableTd {
  padding: 0px;
  height: 49px;
  line-height: 49px;
}
.ShipperForm {
  border: 1px solid #d3d8de;
  box-shadow: none;
  font-size: 12px;
  line-height: 34px;
  height: 34px;
  border-radius: 0.25rem;
}
.clear {
  clear: both;
}
.ShipperFormLabel {
  width: 35%;
  float: left;
  font-size: 12px;
  line-height: 34px;
  height: 34px;
}
.ShipperFormContent {
  width: 65%;
  float: left;
}
.ShipperInput {
  width: 90%;
  margin: 0 auto;
}
.ShipperMargin {
  margin-bottom: 16px;
}
.MarginTop {
  margin-top: 16px;
}
.PaginationStyle {
  float: right;
  margin-top: 8px;
}
.panelTitle {
  padding-left: 15px;
  text-align: left;
}
.ReceiptTableTitle {
  list-style: none;
  float: left;
  color: #909399;
  padding: 12px 32px;
  border: 1px solid #ebeef5;
  overflow: hidden;
  user-select: none;
  text-align: left;
  background-color: #fff;
  font-size: 14px;
  font-weight: 700;
  width: 20%;
}
.ButtonColor {
  color: #fff !important;
}
.ReceiptTableContent {
  padding: 12px 32px;
  list-style: none;
  float: left;
  font-size: 14px;
  line-height: 24px;
  height: 54px;
  color: #606266;
  overflow: hidden;
  user-select: none;
  text-align: left;
  background-color: #fff;
  min-width: 300px;
  width: 20%;
  border: 1px solid #ebeef5;
}
.GoodsTip {
  color: red;
  text-align: left;
  font-size: 12px;
  line-height: 32px;
}
</style>



// WEBPACK FOOTER //
// src/components/ContractManagement/AddOutbound.vue